/* MIRROR · Página de links: tambor 3D, palabra gigante ajustada, hoja de salida y continuación. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopMQ = window.matchMedia('(min-width: 990px)');

  /* ======================================================================
     Tambor 3D: tarjetas en un cilindro cóncavo que gira sin fin.
     Posición no lineal: x' = x · (1 + a·|u|) y escala = derivada (1 + 2a·|u|),
     así las piezas crecen hacia los bordes sin pisarse (como en la referencia).
     ====================================================================== */
  if (!customElements.get('mirror-drum')) {
    class MirrorDrum extends HTMLElement {
      connectedCallback() {
        this.tiles = Array.from(this.querySelectorAll('.ml-tile'));
        if (!this.tiles.length) return;
        this.speedSetting = parseFloat(this.dataset.speed || '35');
        this.curve = parseFloat(this.dataset.curve || '60') / 100;
        this.offset = 0;
        this.boost = 0;
        this.visible = true;
        this.last = 0;
        this.setup = this.setup.bind(this);
        this.frame = this.frame.bind(this);

        this.ensureLength();
        this.setup();
        this.classList.add('is-ready');

        this.ro = new ResizeObserver(this.setup);
        this.ro.observe(this);
        desktopMQ.addEventListener('change', this.setup);

        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start();
        });
        this.io.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.start();
        });

        // Un poco de inercia al hacer scroll (sensación física)
        var lastY = window.scrollY;
        window.addEventListener('scroll', () => {
          var dy = window.scrollY - lastY;
          lastY = window.scrollY;
          this.boost = Math.max(-40, Math.min(40, this.boost + dy * 0.35));
        }, { passive: true });

        if (reduceMotion) this.render(); else this.start();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        cancelAnimationFrame(this.raf);
      }

      /* Clona piezas hasta cubrir con holgura el largo visible */
      ensureLength() {
        var originals = this.tiles.slice();
        var guard = 0;
        while (this.tiles.length < 14 && guard < 6) {
          originals.forEach((t) => {
            var c = t.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.removeAttribute('data-shopify-editor-block');
            this.appendChild(c);
            this.tiles.push(c);
          });
          guard++;
        }
      }

      setup() {
        this.vertical = desktopMQ.matches;
        var rect = this.getBoundingClientRect();
        var t = this.tiles[0].getBoundingClientRect();
        // tamaño sin transformar
        var w = this.tiles[0].offsetWidth || t.width;
        var h = this.tiles[0].offsetHeight || t.height;
        this.tileSize = this.vertical ? h : w;
        this.gap = this.vertical ? Math.round(h * 0.1) : Math.round(w * 0.12);
        this.step = this.tileSize + this.gap;
        this.loop = this.step * this.tiles.length;
        this.half = (this.vertical ? rect.height : rect.width) / 2 || 1;
        this.render();
      }

      start() {
        if (reduceMotion || this.running) return;
        this.running = true;
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.frame);
      }

      frame(now) {
        if (!this.visible || document.hidden) { this.running = false; return; }
        var dt = Math.min(64, now - this.last);
        this.last = now;
        var base = 0.012 + this.speedSetting * 0.0011; // px por ms
        this.offset += (base + this.boost * 0.002) * dt;
        this.boost *= 0.92;
        this.render();
        this.raf = requestAnimationFrame(this.frame);
      }

      render() {
        var n = this.tiles.length;
        var a = 0.08 + this.curve * 0.42;          // separación extra hacia bordes
        var maxAngle = 12 + this.curve * 40;       // inclinación máxima
        var half = this.half;
        var loop = this.loop;
        for (var i = 0; i < n; i++) {
          var x = ((i * this.step - this.offset) % loop + loop) % loop - loop / 2;
          var u = x / half;
          var au = Math.min(Math.abs(u), 1.6);
          var pos = x * (1 + a * au);
          var scale = Math.min(1 + 2 * a * au * 0.55, 1.9);
          var angle = Math.max(-1, Math.min(1, u)) * maxAngle;
          var hidden = Math.abs(pos) > half + this.tileSize * 1.2;
          var tr = this.vertical
            ? 'translate(-50%,-50%) translate3d(0,' + pos.toFixed(1) + 'px,0) rotateX(' + angle.toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')'
            : 'translate(-50%,-50%) translate3d(' + pos.toFixed(1) + 'px,0,0) rotateY(' + (-angle).toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
          var tile = this.tiles[i];
          tile.style.transform = tr;
          tile.style.visibility = hidden ? 'hidden' : 'visible';
          tile.style.zIndex = String(100 - Math.round(au * 50));
        }
      }
    }
    customElements.define('mirror-drum', MirrorDrum);
  }

  /* ======================================================================
     Página: palabra gigante + clics con puente + hoja + continuación
     ====================================================================== */
  if (!customElements.get('mirror-links')) {
    class MirrorLinks extends HTMLElement {
      connectedCallback() {
        this.Bridge = window.MirrorBridge;
        this.sheet = this.querySelector('[data-ml-sheet]');
        this.cards = Array.from(this.querySelectorAll('.ml-card'));

        this.fitWords();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitWords());
        this.ro = new ResizeObserver(() => this.fitWords());
        this.cards.forEach((c) => this.ro.observe(c));

        this.addEventListener('click', this.onClick.bind(this));
        this.bindSheet();
        this.maybeContinue();
        this.showHint();
        this.debug();
      }

      /* Ajusta la palabra para que ocupe ~94 % del ancho de la tarjeta */
      fitWords() {
        this.cards.forEach((card) => {
          var word = card.querySelector('[data-ml-fit]');
          if (!word) return;
          var target = card.clientWidth * 0.94;
          var maxH = card.clientHeight * 0.62;
          word.style.fontSize = '100px';
          var w = word.scrollWidth || 1;
          var size = Math.min(100 * (target / w), maxH / 0.9);
          word.style.fontSize = Math.max(40, Math.floor(size)) + 'px';
        });
      }

      actionFrom(card) {
        return {
          type: card.dataset.bridge,
          go: card.dataset.go,
          label: card.dataset.label,
          phone: card.dataset.phone || this.dataset.phone,
          text: card.dataset.text || '',
          url: card.getAttribute('href')
        };
      }

      onClick(e) {
        var adv = e.target.closest('[data-ml-advisor]'); if (adv) { var waCard = this.querySelector('.ml-card[data-bridge="wa"]'); if (waCard) { e.preventDefault(); waCard.click(); } return; } var card = e.target.closest('.ml-card');
        if (!card || !this.Bridge) return;
        var type = card.dataset.bridge;
        if (type !== 'wa' && type !== 'community') {
          this.Bridge.track('tap', { type: 'link', go: card.dataset.go, label: card.dataset.label });
          return; // enlaces normales: navegación estándar
        }
        if (!this.Bridge.inApp) {
          this.Bridge.track('tap', { type: type, go: card.dataset.go, label: card.dataset.label, inApp: false });
          return; // navegador real: wa.me abre WhatsApp
        }
        e.preventDefault();
        var action = this.actionFrom(card);
        this.pending = action;
        this.Bridge.open(action, {
          onBlocked: (continueUrl) => this.openSheet('escape', continueUrl)
        }, this.dataset.escapeMode || 'guide');
      }

      bindSheet() {
        if (!this.sheet) return;
        this.sheet.addEventListener('click', (e) => {
          if (e.target.closest('[data-ml-sheet-close]')) {
            this.Bridge && this.Bridge.track('sheet_close', {});
            this.closeSheet();
          }
          var copyBtn = e.target.closest('[data-ml-copy]');
          if (copyBtn && this.Bridge) {
            var value = copyBtn.getAttribute('data-ml-copy');
            this.Bridge.copy(value.replace(/\s/g, '')).then(() => {
              var original = copyBtn.firstChild.textContent;
              copyBtn.firstChild.textContent = (copyBtn.dataset.copied || 'Copiado') + ' ';
              setTimeout(() => { copyBtn.firstChild.textContent = original; }, 1800);
            });
            this.Bridge.track('copy_number', {});
          }
          var browserBtn = e.target.closest('[data-ml-open-browser]');
          if (browserBtn && this.Bridge) {
            this.Bridge.copy(this.continueUrl || window.location.href);
            this.Bridge.openInBrowser(this.continueUrl || window.location.href);
          }
          var linkBtn = e.target.closest('[data-ml-copy-link]');
          if (linkBtn && this.Bridge) {
            this.Bridge.copy(this.continueUrl || window.location.href).then(() => {
              var label = linkBtn.querySelector('span');
              if (!label) return;
              var original = label.textContent;
              label.textContent = linkBtn.dataset.copied || original;
              setTimeout(() => { label.textContent = original; }, 2400);
            });
            this.Bridge.track('copy_link', {});
          }
          var cont = e.target.closest('[data-ml-continue]');
          if (cont && this.Bridge) {
            this.Bridge.track('continue_tap', { go: this.pending && this.pending.go });
            this.Bridge.clearIntent();
            setTimeout(() => this.closeSheet(), 400);
          }
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.sheet && !this.sheet.hidden) this.closeSheet();
        });
      }

      openSheet(state, continueUrl) {
        if (!this.sheet) return;
        this.continueUrl = continueUrl;
        this.sheet.querySelectorAll('[data-state]').forEach((el) => { el.hidden = el.dataset.state !== state; });
        this.sheet.classList.toggle('is-escape', state === 'escape');
        // El botón automático solo en Android (en iPhone/TikTok dispara el aviso de error)
        var browserBtn = this.sheet.querySelector('[data-ml-open-browser]');
        if (browserBtn && this.Bridge) browserBtn.hidden = !this.Bridge.isAndroid;
        this.hideHint();
        this.sheet.hidden = false;
        requestAnimationFrame(() => this.sheet.classList.add('is-open'));
        var focusTarget = this.sheet.querySelector('[data-state="' + state + '"] .ml-btn:not([hidden])');
        if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 350);
        this.Bridge && this.Bridge.track('sheet_open', { state: state, go: this.pending && this.pending.go });
      }

      closeSheet() {
        if (!this.sheet) return;
        this.sheet.classList.remove('is-open');
        setTimeout(() => { this.sheet.hidden = true; }, 380);
      }

      /* Aviso superior (solo dentro de TikTok/Instagram) con flecha al botón ••• */
      showHint() {
        var hint = this.querySelector('[data-ml-hint]');
        if (!hint || !this.Bridge || !this.Bridge.inApp) return;
        try { if (sessionStorage.getItem('ml_hint_closed')) return; } catch (e) {}
        hint.hidden = false;
        setTimeout(() => hint.classList.add('is-visible'), 900);
        hint.querySelector('[data-ml-hint-close]')?.addEventListener('click', () => {
          try { sessionStorage.setItem('ml_hint_closed', '1'); } catch (e) {}
          this.hideHint();
          this.Bridge.track('hint_close', {});
        });
        this.Bridge.track('hint_shown', {});
      }

      hideHint() {
        var hint = this.querySelector('[data-ml-hint]');
        if (!hint || hint.hidden) return;
        hint.classList.remove('is-visible');
        setTimeout(() => { hint.hidden = true; }, 400);
      }

      /* Reabierto en el navegador real con ?go=N → un toque para continuar */
      maybeContinue() {
        if (!this.Bridge) return;
        var intent = this.Bridge.readIntent();
        if (!intent.go) return;
        if (this.Bridge.inApp) return; // dentro de TikTok la guía solo sale cuando tocan contacto
        var card = this.cards.find((c) => c.dataset.go === intent.go);
        if (!card) { this.Bridge.clearIntent(); return; }
        var action = this.actionFrom(card);
        this.pending = action;
        this.Bridge.track('escaped', { from: intent.from, go: intent.go, type: action.type });

        var btn = this.sheet && this.sheet.querySelector('[data-ml-continue]');
        if (btn) btn.setAttribute('href', action.type === 'wa' ? this.Bridge.waWebUrl(action.phone, action.text) : action.url);
        var lead = this.sheet && this.sheet.querySelector('[data-ml-continue-label]');
        if (lead) lead.textContent = action.label || '';
        this.openSheet('continue', window.location.href);
      }

      debug() {
        var box = this.querySelector('[data-ml-debug]');
        var on = box || /[?&]debug=1/.test(window.location.search);
        if (!on || !this.Bridge) return;
        if (!box) {
          box = document.createElement('pre');
          box.className = 'ml-debug';
          this.appendChild(box);
        }
        var B = this.Bridge;
        var paint = () => {
          box.textContent =
            'app: ' + (B.app || 'navegador') + '  |  ios: ' + B.isIOS + '  |  android: ' + B.isAndroid + '\n' +
            'UA: ' + navigator.userAgent + '\n\n' +
            B.log().slice(-12).map((l) => new Date(l.t).toLocaleTimeString() + '  ' + l.event + (l.type ? ' · ' + l.type : '') + (l.go ? ' · go=' + l.go : '')).join('\n');
        };
        paint();
        window.addEventListener('mirror:bridge', paint);
      }
    }
    customElements.define('mirror-links', MirrorLinks);
  }
})();
